import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  dateField,
  prefixFields,
  repeatableSection,
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import {
  getEntityFields,
  getEntityMyClientFields,
} from 'app/modules/goAML/formConfig/fields/entityFields';
import {
  getSignatoryFields,
  getSignatoryMyClientFields,
} from 'app/modules/goAML/formConfig/fields/signatoryFields';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

const getAccountRawFields = (
  referenceTables: GoamlReferenceTables,
  opts?: { myClient?: boolean },
): FormFields<FieldValues> => {
  const myClient = opts?.myClient ?? false;

  return [
    textField({
      name: 'institution_name',
      label: 'Institution name',
      required: true,
    }),
    textField({ name: 'institution_code', label: 'Institution Code' }),
    textField({ name: 'swift', label: 'SWIFT' }),
    selectField({
      name: 'non_bank_institution',
      label: 'Is banking institution?',
      options: [
        { value: '0', text: 'Yes' },
        { value: '1', text: 'No' },
      ],
    }),
    textField({ name: 'branch', label: 'Branch' }),
    textField({ name: 'account', label: 'Account number', required: true }),
    selectField(
      {
        name: 'currency_code',
        label: 'Currency code',
        required: myClient,
        refTable: 'currency_code',
      },
      referenceTables,
    ),
    textField({
      name: 'account_name',
      label: 'Account name',
      required: myClient,
    }),
    textField({ name: 'iban', label: 'IBAN' }),
    textField({
      name: 'client_number',
      label: 'Client number',
      required: myClient,
    }),
    selectField(
      {
        name: 'personal_account_type',
        label: 'Account type',
        required: myClient,
        refTable: 'account_type',
      },
      referenceTables,
    ),
    dateField({ name: 'opened', label: 'Opened date', required: myClient }),
    dateField({ name: 'closed', label: 'Closed date' }),
    textField({ name: 'balance', label: 'Balance', required: myClient }),
    dateField({ name: 'date_balance', label: 'Date balance' }),
    selectField(
      {
        name: 'status_code',
        label: 'Account status',
        required: myClient,
        refTable: 'account_status',
      },
      referenceTables,
    ),
    textField({
      name: 'beneficiary',
      label: 'Beneficiary',
      required: myClient,
    }),
    textareaField({
      name: 'beneficiary_comment',
      label: 'Beneficiary comment',
    }),
    textareaField({ name: 'comments', label: 'Account comments' }),
  ];
};

export const getAccountFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  ...getAccountRawFields(referenceTables),
  ...prefixFields('t_entity', getEntityFields(referenceTables)),
  repeatableSection({
    name: 'signatory',
    label: 'Signatories',
    fields: getSignatoryFields(referenceTables),
  }),
];

export const getAccountMyClientFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  ...getAccountRawFields(referenceTables, { myClient: true }),
  ...prefixFields('t_entity', getEntityMyClientFields(referenceTables)),
  repeatableSection({
    name: 'signatory',
    label: 'Signatories',
    fields: getSignatoryMyClientFields(referenceTables),
  }),
];
